import BaseEntity from '@/entities/BaseEntity';

export default class LeadgenForm extends BaseEntity {
  id = null;
  platform = null;
  external_id = null;
  name = '';
  leads_count = 0;
  source_profile_id = null;
  leads_fetched_at = null;

  leads_count_by_campaigns = null;

  notifications = {
    enabled: false,
    to: [],
    emails: [],
    frequency: null,
    hour: 8,
    include_lead_data: true,
    rule_ids: [],
  };

  notification_rules = [];

  // The pixel the lead status changes are sent to: { ad_account_id, pixel_id } or null.
  crm_pixel = null;

  // The names of the answered fields, the campaigns of the leads and the current user's visible
  // columns of the lead list (null: the default ones); only in the response of a single form.
  lead_fields = [];
  lead_campaigns = [];
  columns = null;

  constructor(rawData) {
    super();

    if (rawData['leads_fetched_at']) {
      rawData['leads_fetched_at'] = new Date(rawData['leads_fetched_at']);
    }

    this.updateWith(rawData);
  }
}
